import type { SVGProps } from 'react';

interface EquipmentIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function EquipmentIcon({ className, ...props }: EquipmentIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="4.5 4.35 15.0 15.13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M10.6689 5.39453C11.614 4.85495 12.7777 4.86962 13.709 5.43262L17.5518 7.75586C18.4503 8.29912 18.9998 9.27322 19 10.3232V16.5205L18.9893 16.7246C18.887 17.7333 18.0357 18.5205 17 18.5205H7L6.7959 18.5098C5.78723 18.4075 5 17.5562 5 16.5205V10.373C5.00013 9.36337 5.5076 8.42611 6.3418 7.87305L6.5127 7.76758L10.6689 5.39453ZM12.9326 6.71582C12.4671 6.43452 11.8855 6.42768 11.4131 6.69727L7.25586 9.07031C6.78844 9.33727 6.50014 9.83478 6.5 10.373V16.5205C6.5 16.7966 6.72386 17.0205 7 17.0205H7.75V11.0205C7.75009 10.3302 8.3097 9.77051 9 9.77051H15C15.6903 9.77051 16.2499 10.3302 16.25 11.0205V17.0205H17C17.2761 17.0205 17.5 16.7967 17.5 16.5205V10.3232C17.4998 9.79844 17.2254 9.31166 16.7764 9.04004L12.9326 6.71582ZM9.25 15.2705V17.0205H14.75V15.2705H9.25ZM9.25 13.7705H14.75V11.2705H9.25V13.7705Z" fill="currentColor"/>
    </svg>
  );
}
